module.exports = __webpack_public_path__ + "img/arrowRight.4e21446e.svg";